<template>
	<main class="main-wrapper flex-grow-1">
<div class="d-flex align-items-center bg-white">
		<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
						<div class="font-m">{{topTitle}}</div>
		</div>
</div>
<div class="divider"></div>
<!-- subtabs -->
<div class="container container--narrow mgt-50 mgb-50" v-if="orderData.paymentPrice === 0">
		<div class="t-headline11 l-spacing72 font-m">{{$t('901')}}</div>
		<div class="mgt-8 t-body6 t-color-bodyGrayA font-r ">{{$t('902')}}<br>
						{{$t('903')}}
			</div>

		<div class="mdc-card mgt-16">
			<div class="t-headline7 font-m l-spacing6 pdt-24 pdl-24">{{$t('904')}}</div>
			<div v-for="(purchased, index) in purchasedData" :key="index">
						<div class="pdt-8 pdb-8 pdl-24 pdr-24" :class="index > 0 ? 'pdb-8 pdr-24' : ''">
										<div class="mgt-16 t-body3 font-r l-spacing42 t-color-bodyGrayA">{{$t('905')}}</div>
										<div class="mgt-6 t-body1 font-r l-spacing42">{{orderData.goods.name}}</div>

										<div class="mgt-16 t-body3 font-r l-spacing42 t-color-bodyGrayA"> {{$t('906')}}</div>
										<div class="mgt-6 t-body1 font-r mgb-8">{{$moment(purchased.orderDate).format('L')}}</div>

										<div class="mgt-16 t-body3 font-r l-spacing42 t-color-bodyGrayA" v-if="fetchType=='LEARN'">{{$t('907')}}</div>
										<div class="mgt-6 t-body1 font-r " v-if="fetchType=='LEARN'">{{purchased.progressRate}}%</div>
						</div>
						<div v-if="purchasedData.length-1 > index" class="divider mgt--8"></div>
			</div>
		</div>
		<div class="t-subtitle5 font-m l-spacing54 mgt-24">{{$t('908')}}</div>
		<div class="mgt-8 t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-22 mgb-8">
						<div class="t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-26">{{$t('909')}} </div>
						<div class="t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-26">{{$t('910')}}</div>
						<div class="t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-26">{{$t('911')}}</div>

		</div>
		<div class="mgt-50">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8" @click='moveInformation()' @keypress='moveInformation()' tabindex="0">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-body2 font-r">{{$t('912')}}</span>
						</button>
						<button class="mdc-button mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText" @click='moveTotalDegree()' @keypress='moveTotalDegree()' tabindex="0">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-body2 font-r">{{$t('913')}}</span>
						</button>
		</div>
</div>
<div class="container container--narrow mgt-50 mgb-50 " v-if="orderData.paymentPrice > 0">
			<div class="t-headline11 l-spacing72 font-m">{{$t('438')}}</div>
			<div class="mgt-8 t-body6 t-color-bodyGrayA font-r ">
				{{$t('439')}}
				<br>
				{{$t('440')}}
			</div>
			<div class="mdc-card mgt-16">
							<div class="pda-24">
										<div class="t-subtitle5 font-m l-spacing6">{{$t('441')}}</div>
										<div v-for="(purchased, index) in purchasedData" :key="index">
											<div class="mgt-16 t-body3 font-r l-spacing42 t-color-bodyGrayA">{{$t('442')}}</div>
											<div class="mgt-6 t-body1 font-r l-spacing42">{{orderData.goods.name}}</div>

											<div class="mgt-16 t-body3 font-r l-spacing42 t-color-bodyGrayA">{{$t('443')}}</div>
											<div class="mgt-6 t-body1 font-r ">{{$moment(purchased.orderDate).format('L')}}</div>

											<div class="mgt-16 t-body3 font-r l-spacing42 t-color-bodyGrayA" v-if="fetchType=='LEARN'">{{$t('907')}}</div>
											<div class="mgt-6 t-body1 font-r " v-if="fetchType=='LEARN'">{{purchased.progressRate}}%</div>
											<div v-if="purchasedData.length-1 > index"><hr class="divider"></div>
										</div>
							</div>
			</div>
			<div class="t-subtitle5 font-m l-spacing54 mgt-24">{{$t('445')}}</div>
			<div class="mgt-8 t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-22 mgb-8">
				<div class="t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-26">{{$t('446')}}</div>
				<div class="t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-26">{{$t('447')}}</div>
				<div class="t-body3 font-r t-color-bodyGrayA l-spacing42 t-line-h-26">{{$t('448')}}</div>
			</div>
			<div class="mgt-50">
							<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8" @click='moveInformation()' @keypress='moveInformation()' tabindex="0">
											<div class="mdc-button__ripple"></div>
											<span class="mdc-button__label t-body2 font-r">{{$t('449')}}</span>
							</button>
							<button class="mdc-button mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText" @click='moveTotalDegree()' @keypress='moveTotalDegree()' tabindex="0">
											<div class="mdc-button__ripple"></div>
											<span class="mdc-button__label t-body2 font-r">{{$t('450')}}</span>
							</button>
			</div>
</div>
</main>
</template>

<script>
/**
 * 구매하기 - 중복 구매/신청 컴포넌트(sales - Duplicate purchase / enrollment component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import salesApi from '@/api/salesApi.js'
import {MDCRipple} from '@material/ripple'

export default {
	data() {
		return {
			orderData: {},
			purchasedData: [],
			paymentText: '',
			topTitle:'',
			fetchType:''
		}
	},
	mounted() {
		// document.documentElement.style.overflow = 'auto'
		// window.onscroll = null
		this.fetchType = this.$route.query.fetchType
		this.fetchData()
		this.setMaterialUi()
		window.onpopstate = function(event) {
     		if(this.fetchType==='LEARN'){
				let id = localStorage.getItem('productId')
				this.$router.push(`/degree/${id}?type=ListTotal`)
			} else {
				let id = localStorage.getItem('productId')
				this.$router.push(`/independent/exam/${id}?listType=total`)
			}
   		};
	},
	
	methods: {
		async fetchData() {
			const isMicro = this.$route.query.type && this.$route.query.type === "MICRO";
			let params = this.setParams()
			// get sales goods information
			try {
				const orderResult = isMicro ? await salesApi.salesMicroGoodsOrder(params) : await salesApi.salesGoodsOrder(params);
				const response = orderResult;
				this.orderData = response.data.data
				this.topTitle = this.orderData.paymentPrice ? this.$t('437') : this.$t('900')
				let headerTitle = localStorage.getItem('brandName');
				this.$parent.setTopAppBarCustom({
					leftBtnMode: 'close',
					rightBtnMode: '',
					title: headerTitle,
					leftBtnMethod: () => {
						if(this.fetchType==='LEARN'){
                            let id = localStorage.getItem('productId')
                            this.$router.push(`/degree/${id}?type=ListTotal`)
                        } else {
                            let id = localStorage.getItem('productId')
                            this.$router.push(`/independent/exam/${id}?listType=total`)
                        }
					},
					rightBtnMethod: '',
				})
				
			} catch (error) {
				console.log("Duplicate fetch Error : ", error);
			}

			// 중복 구매 목록(get Duplicate purchase list)
			try {
				const purchasedResult = isMicro ? await salesApi.salesMicroGoodsPurchased(params) : await salesApi.salesGoodsPurchased(params)
				this.purchasedData = purchasedResult.data.data
			} catch (error) {
				console.log("Purchased fetch error : ", error);
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			 let params={};
			if(this.$route.query.fetchType=='LEARN'){
				params = {
					goodsId: this.$route.params.goodsid,
					fetchType:'LEARN',
					type: this.$route.params.type
				}
			} else {
				params = {
					goodsId: this.$route.params.goodsid,
					fetchType:'EXAM',
					type: this.$route.params.type
				}
			}
			return params
			
		},
		
		// 결제 취소(move prev page)
		moveTotalDegree() {
			this.$router.go(-1)
		},

		// 상품 정보 화면으로 이동(move sales information)
		moveInformation() {
			this.$router.push({
				name:'SalesInformation', 
				params: {goodsid: this.$route.params.goodsid},
				query: this.$route.query
			})
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
		
	}

}
</script>